(function() {
  'use strict';
  
  // Accordionセクションを移動する関数
  function moveAccordionsToContentArea() {
    const contentArea = document.querySelector('.faq-content-area');
    
    if (!contentArea) {
      return false;
    }
    
    // ページ全体からAccordionセクションを取得
    const accordionSections = document.querySelectorAll('.section-accordion');
    
    if (accordionSections.length === 0) {
      return false;
    }
    
    // 各Accordionセクションをコンテンツエリアに移動
    accordionSections.forEach(section => {
      // すでにfaq-content-area内にある場合はスキップ
      if (contentArea.contains(section)) {
        return;
      }
      
      // 親要素(shopify-section)を取得
      const parentSection = section.closest('.shopify-section.dynamic-section');
      
      // セクションを移動
      contentArea.appendChild(section);
      
      // 元の親要素が空になったら削除
      if (parentSection && parentSection.children.length === 0) {
        parentSection.remove();
      }
    });
    
    return true;
  }
  
  // 目次を生成する関数
  function generateTOC() {
    const tocList = document.getElementById('faq-toc-list');
    const contentArea = document.querySelector('.faq-content-area');
    
    if (!tocList || !contentArea) {
      return;
    }
    
    // 既存の目次をクリア
    tocList.innerHTML = '';
    
    // コンテンツエリア内のAccordionセクションを取得
    const accordionSections = contentArea.querySelectorAll('.section-accordion');
    
    if (accordionSections.length === 0) {
      return;
    }
    
    // 各Accordionセクションの見出しのみを処理
    accordionSections.forEach((section, index) => {
      // セクション見出しを取得
      const sectionHeadingElement = section.querySelector('.snip-headings__heading') || 
                                     section.querySelector('h2') || 
                                     section.querySelector('.heading') ||
                                     section.querySelector('[class*="heading"]');
      
      if (!sectionHeadingElement || sectionHeadingElement.textContent.trim() === '') {
        return;
      }
      
      const sectionId = section.getAttribute('data-section-id') || `accordion-section-${index}`;
      
      // セクションにIDを設定
      if (!section.id) {
        section.id = sectionId;
      }
      
      const li = document.createElement('li');
      const a = document.createElement('a');
      
      a.href = `#${section.id}`;
      a.textContent = sectionHeadingElement.textContent.trim();
      a.dataset.sectionId = section.id;
      
      // クリックイベント
      a.addEventListener('click', function(e) {
        e.preventDefault();
        const targetSection = document.getElementById(section.id);
        if (targetSection) {
          const offset = 100;
          const elementPosition = targetSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
          
          // アクティブ状態を更新
          updateActiveTOCItem(section.id);
        }
      });
      
      li.appendChild(a);
      tocList.appendChild(li);
    });
  }
  
  // アクティブな目次項目を更新
  function updateActiveTOCItem(sectionId) {
    const tocLinks = document.querySelectorAll('.faq-toc__list a');
    tocLinks.forEach(link => {
      if (link.dataset.sectionId === sectionId) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }
  
  // スクロール位置に応じてアクティブ項目を更新
  function updateActiveOnScroll() {
    const contentArea = document.querySelector('.faq-content-area');
    if (!contentArea) return;
    
    const sections = contentArea.querySelectorAll('.section-accordion');
    const scrollPosition = window.scrollY + 200;
    
    let currentSectionId = null;
    
    sections.forEach(section => {
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;
      
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        currentSectionId = section.id;
      }
    });
    
    if (currentSectionId) {
      updateActiveTOCItem(currentSectionId);
    }
  }
  
  // 初期化
  function init() {
    // Accordionセクションを移動してから目次を生成
    const initProcess = function() {
      moveAccordionsToContentArea();
      setTimeout(generateTOC, 200);
    };
    
    // DOMが完全に読み込まれた後に実行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProcess);
    } else {
      initProcess();
    }
    
    // ページ読み込み後にも実行
    window.addEventListener('load', function() {
      setTimeout(initProcess, 500);
    });
    
    // スクロールイベント
    let scrollTimeout;
    window.addEventListener('scroll', function() {
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      scrollTimeout = setTimeout(updateActiveOnScroll, 100);
    });
  }
  
  init();
})();
